import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'ng-casto-closet-doors-administration-message',
  templateUrl: './closet-doors-administration-message.component.html',
})
export class ClosetDoorsAdministrationMessageComponent {
  title: string;
  message: string;
  messages: string[];

  constructor(public modalService: ModalService) {
    this.title = this.modalService.currentDatas.title;
    this.message = this.modalService.currentDatas.message;
    this.messages = this.modalService.currentDatas.messages;
  }
}
